export enum TemplateMessageSF {
  ScheduleConfirmation = 'schedule_confirmation',
  RescheduleConfirmation = 'reschedule_confirmation',
  WithSSSC = '_with_sssc',
  WithoutSSSC = '_without_sssc',
  WithMSV = '_with_msv',
  CancelationConfirmation = 'cancelation_confirmation',
  DeliveryDateConfirmation = 'delivery_date_confirmation',
  PUDdriverConfirmation = 'PUD_driver_confirmation',
}

// Service_Status - (Status do serviço: confirmado, cancelado)
// Schedule_Id – (ID Interno do agendamento com 8 dígitos, exemplo 13040017)
export interface IScheduleConfigSF {
  Service_Status: string;
  Schedule_Id: string;
  Schedule_source: string;
  Date: string;
  Time: string;
  Total?: string;
  Total_Discount?: string;
  Total_Wo_Tax: string;
  Save_to_Calendar_Link?: string;
  Schedule_Datetime: string; // dd/mm/aaaa hh:mm:ss
}

export interface IDealerSF {
  Dealer_Address_Link: string;
  Dealer_Name: string;
  Dealer_Address?: string;
  Service_Advisor?: string;
}

export interface ICoordinates {
  lat: string;
  lng: string;
}

export interface IVehicleSF {
  Vehicle_Name: string;
  License_Plate: string;
  VIN: string;
  VIN_odometer: string;
  TMA?: string;
  Model_Year?: string;
}

export interface ICustomerSF {
  Customer_GUID: string;
  EmailAddress: string;
  SubscriberKey: string;
  nationalId: string;
  Document_Number: string;
  Customer_Cellphone?: string;
  Customer_Comment?: string;
  FirstName?: string;
}

export interface ITemplateConfigSF {
  Template_message: TemplateMessageSF;
  Market: string;
}

export interface IRecallSF {
  Recall_Cost_1?: string;
  Recall_Description_1?: string;
  Recall_Cost_2?: string;
  Recall_Description_2?: string;
  Recall_Cost_3?: string;
  Recall_Description_3?: string;
  Recall_Cost_4?: string;
  Recall_Description_4?: string;
  Recall_Cost_5?: string;
  Recall_Description_5?: string;
  Recall_Subtotal?: string;
}

export interface IRevisionServiceSF {
  Service_Description?: string; //nome da revisão 3 revisão
  Service_Item_1?: string; //itens complementares da revisao
  Service_Item_2?: string;
  Service_Item_3?: string;
  Service_Item_4?: string;
  Service_Item_5?: string;
  Service_Item_6?: string;
  Service_Item_7?: string;
  Service_Item_8?: string;
  Service_Item_9?: string;
  Service_Item_10?: string;
  Service_Price?: string; // preco da revisao
  Service_Subtotal?: string; // valor da revisao - a soma das campanhas
}

// delivery_date_confirmation
export interface IConfirmationPUDSF {
  Delivery_Date?: string;
  Delivery_Dealer_Address?: string;
  Delivery_Dealer_Address_Link?: string;
  Delivery_Dealer_Name?: string;
  Delivery_Time?: string;
  Driver_Name?: string;
  Driver_Picture?: string;
}

// PUD_driver_confirmation mudar o noem pq precisa entender
export interface IInfoPUDSF {
  PDL_Address?: string;
  PDL_Date?: string;
  PDL_Description?: string;
  PDL_Discount?: string;
  PDL_Price?: string;
  PDL_Subtotal?: string;
  PDL_Time?: string;
  PDL_Zip_Code?: string;
}

export interface IcampaignsF {
  Service_Discount_Description_1?: string; // campanhas
  Service_Discount_Value_1?: string;
  Service_Discount_Description_2?: string;
  Service_Discount_Value_2?: string;
  Service_Discount_Description_4?: string;
  Service_Discount_Value_4?: string;
  Service_Discount_Description_3?: string;
  Service_Discount_Value_3?: string;
  Service_Discount_Description_5?: string;
  Service_Discount_Value_5?: string;
}

export interface IOptionalServiceSF {
  Additional_Service_Description_1?: string;
  Additional_Service_Discount_1?: string;
  Additional_Service_Price_1?: string;
  Additional_Service_Description_2?: string;
  Additional_Service_Discount_2?: string;
  Additional_Service_Price_2?: string;
  Additional_Service_Description_3?: string;
  Additional_Service_Discount_3?: string;
  Additional_Service_Price_3?: string;
  Additional_Service_Description_4?: string;
  Additional_Service_Discount_4?: string;
  Additional_Service_Price_4?: string;
  Additional_Service_Description_5?: string;
  Additional_Service_Discount_5?: string;
  Additional_Service_Price_5?: string;
  Additional_Service_Subtotal?: string;
}

// TODO esse talvez seja IOLM
export interface IComplementItensSF {
  ComplementValue_1?: string;
  Complement_Description_1?: string;
  ComplementValue_2?: string;
  Complement_Description_2?: string;
  ComplementValue_3?: string;
  Complement_Description_3?: string;
  ComplementValue_4?: string;
  Complement_Description_4?: string;
  ComplementValue_5?: string;
  Complement_Description_5?: string;
  Complement_Price?: string;
}

// Schedule_Service_Code - (Código interno do serviço com 5 dígitos, exemplo 1337)
// Service_Type – (Categoria de serviço agendado: Revisão, Recall e etc)
// Schedule_Intention – (Nome do serviço escolhido, exemplo 1ª revisão; Serviço Leva e Traz - até 15 KM (online)
// Schedule_Intention_Description – string (descrição do serviço ou caso não tenha descrição replicar o Schedule_Intention).
export interface IServicesMarketingSF {
  Service_Type: string;
  Schedule_Service_Code: string;
  Schedule_Intention: string;
  Schedule_Intention_Description: string;
}

export interface ISalesForceJson {
  templateConfig: ITemplateConfigSF;
  scheduleConfig: IScheduleConfigSF;
  customer: ICustomerSF;
  vehicle: IVehicleSF;
  dealer: IDealerSF;
  marketing: IServicesMarketingSF;
  revisionService?: IRevisionServiceSF;
  recallService?: IRecallSF;
  infoPUD?: IInfoPUDSF;
  campaigns?: IcampaignsF;
  optionalService?: IOptionalServiceSF;
  iolmParts?: IComplementItensSF;
}
